import React, { Component } from 'react';
import { Snackbar} from 'react-md';

let openSnackbarFn;

class Message extends Component {
  
    state = {
        autohide: true,
        toasts: [],
    };


    render() {
        return (
            <Snackbar
                id="snackbar"
                toasts={this.state.toasts}
                autohide={this.state.autohide}
                onDismiss={this.dismissToast}
            />
        );
    }
    
    componentDidMount() {
        openSnackbarFn = this.openSnackbar;
    }

    addToast = (text, action, autohide = true) => {
        this.setState((state) => {
            const toasts = state.toasts.slice();
            toasts.push({ text, action });
            return { toasts, autohide };
        });
    };
    
    openSnackbar = ({ message }) => {
        this.addToast(message);
    };
    
    dismissToast = () => {
        const [, ...toasts] = this.state.toasts;
        this.setState({ toasts });
    };
}

export function openSnackbar({ message }) {
    openSnackbarFn({ message });
}

export default Message;


// WEBPACK FOOTER //
// ./src/components/message.js